import { getFirstStreamUserAuth, getContentId, canPlayStream } from 'lib/auth';
import { isEmpty } from 'lib/util';
import { streamSelect, pickerStreamsUnSelect } from 'common/actions/appActions';
import {
    filterPickerStreamsById,
    handleSingleStreamAuthentication
} from 'lib/streamPicker';
import { getPickerStreams } from './openStreamPicker';

export async function selectStreamForAuthUsers (payload) {
    const {
        dispatch,
        authRes,
        pickerStreams = [],
        content,
        feeds = {},
        locationBeforeTransitions = {}
    } = payload;
   
    const { streams = [], placement = '', isEvent } = content;
    const playerSideBarContent = placement.indexOf('playback-page-recommended') !== -1;
    const { query, query: { id, airingId } = {} } = locationBeforeTransitions; 
    
    const { userAuth = [] } = authRes;
    let  contentId = airingId || id;
    let nextPickerStreams = pickerStreams;
    // playerSideBarContent will be true when user clicks on sidebar content on player page
    if (playerSideBarContent) {
        contentId = getContentId(content);
        dispatch(pickerStreamsUnSelect());
        if ( isEvent ) {
            nextPickerStreams = await dispatch(getPickerStreams(content, pickerStreams));
        }
    }

    let filteredStreams = filterPickerStreamsById(nextPickerStreams, contentId);
    if (filteredStreams && Array.isArray(filteredStreams.streams)) {
        filteredStreams = filteredStreams.streams[0]
    }
    // if airing content is not found in pickerStreams, get it from content.streams
    if (!filteredStreams) {
        filteredStreams = streams.filter(stream => stream.id === contentId)[0];
    }

    if (!filteredStreams && !isEmpty(feeds)) {
        const lastFeeds = Object.keys(feeds).map((key) => feeds[key]);
        const lastSelectedStream = streams.filter(({ id }) => lastFeeds.indexOf(contentId) > -1)[0];
        if (lastSelectedStream) {
            filteredStreams = lastSelectedStream;
        }
    }

    // last fallback
    if (!filteredStreams) {
        filteredStreams = getFirstStreamUserAuth(streams, userAuth) || streams[0];      
    }

    // add missing content props that we need to pass to DSS 
    if (filteredStreams && !filteredStreams.content) {
        filteredStreams = { ...filteredStreams, content }
    }
    
    if (canPlayStream(filteredStreams, userAuth, false) && filteredStreams.status !== 'upcoming') {
        dispatch(streamSelect(filteredStreams));
    } else {
        handleSingleStreamAuthentication({
            query,
            dispatch,
            stream: filteredStreams,
            requiredAuths: filteredStreams.authTypes,
            nextSelectedContent: content
        });
    }
}




// WEBPACK FOOTER //
// ./app/lib/streamPicker/selectStreamForAuthUsers.js